import { render } from "./editbank.vue?vue&type=template&id=3e680adc"
import script from "./editbank.vue?vue&type=script&lang=js"
export * from "./editbank.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__